import { render, staticRenderFns } from "./mortgage-list.vue?vue&type=template&id=14b985b2&scoped=true&"
import script from "./mortgage-list.vue?vue&type=script&lang=js&"
export * from "./mortgage-list.vue?vue&type=script&lang=js&"
import style0 from "./mortgage-list.vue?vue&type=style&index=0&id=14b985b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b985b2",
  null
  
)

export default component.exports